/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { SwitchInput } from 'src/components/ts-components/SwitchInput'

interface SettingSwitchProps {
  /** Already Title-cased by the caller. */
  label: string
  hint?: string
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

/**
 * A switch whose value is derived rather than one form field (a tab shown,
 * the border shown, a colour group on), laid out like `SwitchField`.
 */
export const SettingSwitch = ({
  label,
  hint,
  checked,
  onChange,
  disabled,
}: SettingSwitchProps) => (
  <div css={cellStyle}>
    <SwitchInput
      title={label}
      subtitle={hint}
      value={checked}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
)

/** Label and hint on the left, the switch beside them on the right. */
const cellStyle = css`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`
